/*
Render all lineItem forms
- note, directive renders entire table rather than individual form because ng-repeating
  a <tr> directive causes weird issues
*/
import moment from 'moment-timezone';
import poEnums from 'goodeggs-purchase-orders-sdk/purchase_order/enums';
import enums from 'goodeggs-purchase-orders-sdk/enums';

import './style.styl';

angular
  .module(__filename, [
    require('local_modules/filters/display_order_unit').default.name,
    require('local_modules/services/external_urls').default,
    require('local_modules/services/line_item_service').default,
    require('local_modules/directives/drag_anchor').default,
    require('local_modules/directives/drop_target').default,
  ])

  .directive(
    'poLineItemForms',
    ngInject(() => ({
      restrict: 'E',
      scope: {
        form: '=',
        foodhub: '=',
      },
      template: require('./template'),
      controllerAs: 'ctrl',
      bindToController: true,
      replace: true,
      controller: ngInject(function($scope, externalUrls, lineItemService) {
        this.externalUrls = externalUrls;
        this.enums = enums;
        this.poEnums = poEnums;

        this.getCatalogProductLabel = (catalogProduct) => {
          if (catalogProduct == null) {
            return '';
          }
          if ((catalogProduct != null ? catalogProduct.sku : undefined) != null) {
            return `(${catalogProduct.sku}) ${catalogProduct.name}`;
          }
          return catalogProduct.name;
        };

        this.lineItemClass = (lineItemForm) => {
          switch (lineItemForm.status) {
            case 'edited':
              return 'removed warning';
            case 'cancelled':
              return 'removed danger';
            default:
              return '';
          }
        };

        // TODO(jason-h-hu): I decided to jankily hack this interaction because:
        // Panels and accordion menus are the correct way of handling collapsing interactions,
        // but that's a monstrosity to put inside a <table/>. The correct long-term solution
        // is to not use a <table/>
        const updateEditsByLineNumber = (lineItemForms) => {
          this.hasEditsByLineNumber = lineItemForms.reduce((accum, lineItemForm) => {
            const prevValue =
              accum[lineItemForm.number] == null ? false : accum[lineItemForm.number];
            accum[lineItemForm.number] = lineItemForm.status === 'edited' ? true : prevValue;
            return accum;
          }, {});
          this.showEditsByLineNumber = lineItemForms.reduce((accum, lineItemForm) => {
            accum[lineItemForm.number] = false;
            return accum;
          }, {});
        };
        // We need to add a $watch so that we properly display [show/hide edits] after
        // we edit a line item, without refreshing the page. Otherwise, ctrl.form.lineItemForms
        // changes out frm underneath us, but this.{hasEditsByLineNumber, showEditsByLineNumber}
        // are stale, so we don't display the appropriate buttons
        $scope.$watch('ctrl.form.lineItemForms', (updatedLineItemForms) =>
          updateEditsByLineNumber(updatedLineItemForms),
        );
        updateEditsByLineNumber(this.form.lineItemForms);

        this.toggleShowEditLog = (lineNumber) => {
          if (this.showEditsByLineNumber[lineNumber] != null) {
            this.showEditsByLineNumber[lineNumber] = !this.showEditsByLineNumber[lineNumber];
          }
        };
        this.hasEditLog = (lineItemForm) =>
          lineItemForm.status !== 'edited' && this.hasEditsByLineNumber[lineItemForm.number];
        this.showEditLog = (lineItemForm) => this.showEditsByLineNumber[lineItemForm.number];

        this.getFormattedUpdatedAt = (lineItemForm) => {
          return lineItemForm.status === 'edited'
            ? moment(lineItemForm.updatedAt).format('MM/DD hh:mm a')
            : null;
        };

        this.sortByLineItemNumber = (lineItemForm) => lineItemForm.number || Infinity;

        this.sortByStatus = (lineItemForm) => {
          if (['edited', 'cancelled'].includes(lineItemForm.status)) {
            return Infinity;
          }
          return 0;
        };

        this.reverseSortByUpdateTime = (lineItemForm) =>
          moment(lineItemForm.lineItem.updatedAt).valueOf() * -1;

        this.lineItemDragged = (dragScope, dropScope) => {
          const desiredNumber = dropScope.lineItemForm.number;
          const {lineItemForm} = dragScope;
          return $scope.$apply(
            lineItemService.reorder.bind(
              this,
              this.form.lineItemForms,
              lineItemForm,
              desiredNumber,
            ),
          );
        };

        return this;
      }),
    })),
  );

export default __filename;
